import React from "react";
import { Circle, Flex, Text, VStack } from "@chakra-ui/react";

interface NumberedListProps {
  items: JSX.Element[];
}

export const NumberedList = ({ items }: NumberedListProps) => (
  <VStack spacing={4} alignItems="baseline">
    {items.map((item, index) => (
      <Flex key={index} alignItems="center">
        <Circle mr={2} size="26px" style={{ backgroundColor: "#0533FF" }}>
          <Text fontSize={"14px"} fontWeight="bold" color="#fff">
            {index + 1}
          </Text>
        </Circle>
        {item}
      </Flex>
    ))}
  </VStack>
);
